<template>
    <div class="current-plan-wrapper">
        <div class="current-plan-item" v-if="currentPlans.length <= 0" @click="showPlans">
            <div class="current-plan-item-head">
                <div class="current-plan-item-head-left">
                    <div class="current-plan-item-head-left-icon">
                        <DynamicSvg :name="getIconName()" />
                    </div>
                    <div class="current-plan-item-head-left-title">{{ getTitle() }}</div>
                </div>
                <div class="current-plan-item-head-right">
                    <PlanItemButton>{{ $t("billing.buyNow") }}</PlanItemButton>
                </div>
            </div>
            <a-tooltip :title="getDescription()">
                <div class="current-plan-item-description">
                    {{ getDescription() }}
                </div>
            </a-tooltip>
        </div>
        <div class="current-plan-item" v-for="item in currentPlans" :key="item.currentPlan._id" @click="showPlans"
             v-else>
            <div class="current-plan-item-head">
                <div class="current-plan-item-head-left">
                    <div class="current-plan-item-head-left-icon">
                        <DynamicSvg :name="getIconName()" />
                    </div>
                    <div class="current-plan-item-head-left-title">{{ getTitle() }}</div>
                </div>
                <div class="current-plan-item-head-right">
                    <PlanItemButton is-selected>
                        {{ $t("billing.purchased") }}
                        <div class="material-icons">check</div>
                    </PlanItemButton>
                </div>
            </div>
            <div class="current-plan-item-footer">
                <div class="current-plan-item-footer-left">
                    <div class="current-plan-item-footer-left-item" v-if="item.currentPlan.endDate">
                        <TimeoutIcon />
                        {{ getRemainingDays(item.currentPlan) }} {{$t('tables.day')}}
                    </div>
                    <a-tooltip placement="topLeft" v-else>
                        <template slot="title">{{ $t("billing.autoRenew") }}</template>
                        <div class="current-plan-item-footer-left-item" >
                            <RenewIcon />
                        </div>
                    </a-tooltip>
                </div>
                <div class="current-plan-item-footer-right">
                    <div class="current-plan-item-footer-right-item solid">
                        {{ periods[item.currentPlan.period] }}
                    </div>
                    <div
                        class="current-plan-item-footer-right-item"
                        v-if="getQuantity().total > 0"
                    >
                        {{ getQuantity(item).total }} {{ getQuantityText() }}
                    </div>
                    <div
                        class="current-plan-item-footer-right-item"
                        v-if="getQuantity().free > 0"
                    >
                        {{ getQuantity(item).free }} {{ getQuantityText(true) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import DynamicSvg from "../../../../components/DynamicSvg.vue";
import PlanItemButton from "./PlanItemButton.vue";
import RenewIcon from "./svg/RenewIcon.vue";
import TimeoutIcon from "./svg/Timeout.vue";

export default {
    name: "PlanItem",
    components: { TimeoutIcon, RenewIcon, PlanItemButton, DynamicSvg },
    created(){
        this.getDescription();
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        currentPlans: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            icons: {
                whatsapp: "CWhatsapp",
                "whatsapp-business": "WhatsappBusinessNew",
                supsis: "CSupsis",
                chatbot: "ChatbotNew",
                instagram: "CInstagram",
                telegram: "TelegramEntegration",
                custom: "CSupsis",
                appsumo: "AppSumo",
                messenger: "Messenger",
                trendyol: "trendyol",
                "meta-lead": "MetaIcon",
                "customer-tables": "CustomerTables",
                form: "Form",
                automation: "Automation",
                mail: "Mail",
                tasks: "Tasks",
                "artificial-intelligence": "ArtificialIntelligence",
                "webhook": "WebhookIntegration",
                "linkedin": "LinkedinEntegration",
            },
            description: {
                whatsapp: this.$t("billing.packageDescriptions.whatsapp"),
                "whatsapp-business": this.$t("billing.packageDescriptions.whatsappBusiness"),
                supsis: this.$t("billing.packageDescriptions.supsis"),
                chatbot: this.$t("billing.packageDescriptions.chatbot"),
                instagram: this.$t("billing.packageDescriptions.instagram"),
                telegram: this.$t("billing.packageDescriptions.telegram"),
                custom: this.$t("billing.packageDescriptions.custom"),
                messenger: this.$t("billing.packageDescriptions.messenger"),
                trendyol: this.$t("billing.packageDescriptions.trendyol"),
                "meta-lead": this.$t("billing.packageDescriptions.metaLead"),
                "customer-tables": this.$t("billing.packageDescriptions.customerTables"),
                form: this.$t("billing.packageDescriptions.form"),
                automation: this.$t("billing.packageDescriptions.automation"),
                mail: this.$t("billing.packageDescriptions.mail"),
                tasks: this.$t("billing.packageDescriptions.tasks"),
                "artificial-intelligence": this.$t("billing.packageDescriptions.artificialIntelligence"),
                "webhook": this.$t("billing.packageDescriptions.webhook"),
                default: this.$t("billing.packageDescriptions.default"),
            },
            periods: {
                monthly: this.$t("billing.monthly"),
                "monthly-3": this.$t("billing.threeMonthly"),
                "monthly-6": this.$t("billing.sixMonthly"),
                annual: this.$t("billing.yearly"),
                "annual-2": this.$t("billing.twoYearly"),
                forever: this.$t("billing.forever"),
            },
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            features: (state) => state.site.features,
        }),
    },
    methods: {
        ...mapActions({}),
        getIconName() {
            return this.icons[this.type] || "CSupsis";
        },
        getTitle() {
            const title = this.type
                .split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
            const i18nKey = `message.plans.types.${this.type.replace("-", "_")}`;
            return this.$t(i18nKey) === i18nKey ? title : this.$t(i18nKey);
        },
        getDescription() {
            return this.description[this.type] || this.description.default;
        },
        getRemainingDays(currentPlan) {
            return Math.ceil((new Date(currentPlan.endDate) - new Date()) / (1000 * 60 * 60 * 24));
        },
        isFreePlan(item) {
            const { currentPlan: currentPlanAction, plan } = item;
            const maxUsageCount = currentPlanAction.details?.maxUsageCount;
            const selectFeatures = plan?.selectFeatures || [];
            const currentPlan = selectFeatures.find((feature) => feature.count === maxUsageCount);
            return plan?.isFreePlan || currentPlan?.price <= 0;
        },
        showPlans() {
            this.$router.push({
                path: `/billing/plans/${this.type}`,
            });
        },
        getQuantity() {
            const data = { freeCount: 0, paidCount: 0 };
            if (this.type === "supsis") {
                data.freeCount = this.features.freeAgentCount;
                data.paidCount = this.features.maxAgentCount - this.features.freeAgentCount;
            } else if (this.type === "chatbot") {
                data.paidCount = this.features.totalSessionCount;
            } else if (this.type === "whatsapp") {
                data.paidCount = this.features.maxWhatsappChannel;
            } else if (this.type === "whatsapp-business") {
                data.paidCount = this.features.maxBusinessWhatsappChannel;
            } else if (this.type === "instagram") {
                data.paidCount = this.features.maxInstagramChannel;
            } else if (this.type === "messenger") {
                data.paidCount = this.features.maxMessengerChannel;
            } else if (this.type === "meta-lead") {
                data.paidCount = this.features.maxMetaLeadChannel;
            } else if (this.type === "automation") {
                data.paidCount = this.features.maxAutomationTask;
            } else if (this.type === "trendyol") {
                data.paidCount = this.features.maxTrendyolChannel;
            } else if (this.type === "mail") {
                data.paidCount = this.features.maxMailCount;
            } else if (this.type === "linkedin") {
                data.paidCount = this.features.maxLinkedinChannel;
            } else if (this.type === "telegram") {
                data.paidCount = this.features.maxTelegramChannel;
            }
            return {
                total: data.freeCount + data.paidCount,
                free: data.freeCount,
                paid: data.paidCount,
            };
        },
        getQuantityText(isFree) {
            let text = "";
            if (this.type === "supsis") {
                text = "Temsilci";
            } else if (this.type === "chatbot") {
                text = "Oturum";
            } else if (this.type === "automation") {
                text = "Görev";
            } else if (this.type === "mail") {
                text = "Mail";
            } else if (["whatsapp", "whatsapp-business", "instagram", "messenger", "meta-lead", "trendyol", "linkedin", "telegram"].includes(this.type)) {
                text = "Kanal";
            } else {
                text = "Adet";
            }
            return isFree ? `Ücretsiz ${text}` : text;
        },
    },
};
</script>
<style lang="scss" scoped>
.current-plan-wrapper {
    background: white;
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: flex-start;

    .current-plan-item {
        width: 100%;
        cursor: pointer;

        &-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            padding: 10px;
            border-bottom: 1px solid #F1F4F7;

            &-left {
                display: flex;
                align-items: center;
                gap: 10px;

                &-icon {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg {
                        width: 100%;
                        height: 100%;
                    }
                }

                &-title {
                    font-size: 16px;
                    font-weight: bold;
                    text-wrap: nowrap;
                }
            }
        }

        &-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            &-left {
                display: flex;
                align-items: center;
                gap: 5px;
                font-size: 12px;

                &-item {
                    display: flex;
                    align-items: center;
                    gap: 3px;
                }
            }

            &-right {
                display: flex;
                align-items: center;
                gap: 5px;
                font-size: 12px;

                &-item {
                    display: flex;
                    align-items: center;
                    gap: 3px;
                    border: 1px solid #F1F4F7;
                    color: #647491;
                    padding: 0 4px;

                    &.free-item {
                        color: #1BB157;
                    }
                }
            }
        }

        &-description {
            padding: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 64px;
            font-size: 12px;
            color: #8796AF;
        }
    }
}
</style>
